// assets/italicify.js
(function () {
  // Syntax-Optionen: [i]kursiv[/i] oder *kursiv*
  // Falls du nur eine Variante willst, entferne den anderen Regex.

  // [i]...[/i]
  const bbcodeRegex = /\[i\]([\s\S]*?)\[\/i\]/g;

  // *...*  (keine Überschneidung mit **bold** – nur einfache Sternchen)
  const starRegex = /(^|[\s(])\*([^*]+)\*([\s).,!?:;]|$)/g;

  function italicifyNode(node) {
    // Nur Elemente mit Text (keine Inputs/Scripts/Styles)
    if (!node || !node.querySelectorAll) return;

    // Ziel-Selektoren: Überschriften + gängige Richtext-Container
    const targets = node.querySelectorAll('h1, h2, h3, h4, .rte, .rich-text, [data-italicify="true"]');

    targets.forEach((el) => {
      // Nur einmal verarbeiten
      if (el.dataset.italicified === "true") return;

      // HTML als String ziehen
      let html = el.innerHTML;

      // 1) [i]...[/i] → <em>...</em>
      html = html.replace(bbcodeRegex, (m, inner) => `<em>${inner}</em>`);

      // 2) *...* → <em>...</em>  (erhält angrenzende Zeichen vor/nach dem Match)
      html = html.replace(starRegex, (m, pre, inner, post) => `${pre}<em>${inner.trim()}</em>${post}`);

      // Nur updaten, wenn sich etwas geändert hat
      if (html !== el.innerHTML) {
        el.innerHTML = html;
        el.dataset.italicified = "true";
      }
    });
  }

  // Initial nach DOM bereit
  document.addEventListener('DOMContentLoaded', function () {
    italicifyNode(document);

    // Für dynamisch geladene Abschnitte (Shopify Theme Editor, Ajax, etc.)
    const obs = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => italicifyNode(n));
      });
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
